export const PULSE_KINDS = {
  DEFAULT: 'Default',
  WHITE: 'White',
} as const

export const LOADER_KINDS = {
  DEFAULT: 'Default',
  CHECKMARK: 'Checkmark',
} as const
